//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

type ThemeColorsKeys = Omit<(typeof theme)['colors'], 'aliases'>;
export type ThemeColor = ThemeColorsKeys[keyof ThemeColorsKeys];

/**
 * @deprecated `theme` should be imported directly from '@bvengineering/unison-core'.
 * This export only exists for backwards compatibility.
 */
export default theme;
